
import React from "react";
import { BarChart2 } from "lucide-react";
import { useTheme } from "@/contexts/ThemeContext";

interface EmptyStateAnalyticsProps {
  message: string;
}

export function EmptyStateAnalytics({ message }: EmptyStateAnalyticsProps) {
  const { theme } = useTheme();
  const isLightMode = theme === 'light';
  
  return (
    <div className={`flex flex-col items-center justify-center py-12 px-4 border border-dashed rounded-lg
      ${isLightMode 
        ? 'border-gray-300 bg-gray-50/50' 
        : 'border-[#4A4A4A] bg-[#1A1A1A]/30'}`}
    >
      <div className={`w-12 h-12 rounded-full flex items-center justify-center mb-4
        ${isLightMode ? 'bg-gray-100' : 'bg-[#2A2A2A]'}`}
      >
        <BarChart2 className={`w-6 h-6 ${isLightMode ? 'text-gray-500' : 'text-[#9b87f5]'}`} />
      </div>
      <h3 className={`text-lg font-medium mb-2 ${isLightMode ? 'text-gray-800' : 'text-white'}`}>
        No data available
      </h3>
      <p className={`text-sm text-center max-w-md ${isLightMode ? 'text-gray-500' : 'text-[#8E9196]'}`}>
        {message}
      </p>
    </div>
  );
}
